module.exports = __webpack_public_path__ + "static/assets/433e0c4ca6a9a38fffa19b3faf92fb59.gif";